import { HelmetDexteel } from "@dexteel/mesf-core";
import { ProductTypesStatisticsReport } from "./components/ProductTypesStatisticsReport";

export const ProductTypesStatisticsPage = () => {
	return (
		<>
			<HelmetDexteel title="Product Types Statistics" />
			<ProductTypesStatisticsReport />
		</>
	);
};
